import { render } from "./SalaryInformationManage.vue?vue&type=template&id=1529b586"
import script from "./SalaryInformationManage.vue?vue&type=script&lang=js"
export * from "./SalaryInformationManage.vue?vue&type=script&lang=js"

import "./SalaryInformationManage.vue?vue&type=style&index=0&id=1529b586&lang=less"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__